<template>
  <div v-if="currentRoles.name === '标签打印'" class="page-index label-print">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['标签打印-添加批次']" class="btn-left" size="mini" @click="openModel(null)">添加批次</el-button>
      <div style="flex:1"></div>
      <el-select v-if="userInfo.companyList.length > 0" class="search-input2" multiple collapse-tags v-model="query.companyIds" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select class="search-input" v-model="flag" @change="seach">
        <el-option label="普通" value="1"></el-option>
        <el-option label="营销" value="2"></el-option>
      </el-select>
      <el-input  class="search-input" size="mini" v-model="query.query" @keyup.enter.native="seach" placeholder="请输入关键字" />
    </div>
    <el-table
        ref="table"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
      <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="batch"
          label="批次号">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="label.name"
          label="标签名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="product.name"
          label="商品名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="label.address"
          label="产地">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="productDate"
          label="生产日期">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="是否打印">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 1">未打印</div>
          <div v-if="scope.row.status === 2">打印中</div>
          <div v-if="scope.row.status === 3">已完成</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          label="已打印/数量">
        <template slot-scope="scope">
          <div>{{scope.row.printNum + '/' + scope.row.num}}</div>
        </template>
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="120"
          label="操作">
        <template slot-scope="scope">
          <el-tooltip content="详情" placement="top">
            <el-button size="mini" @click.stop="handleDetail(scope.row)">
              <i class="icon el-icon-detail"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="scope.row.printNum < scope.row.num" content="打印" placement="top">
            <el-button size="mini" @click.stop="handlePrint(scope.row)">
              <i class="icon el-icon-print"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加标签"
        :visible.sync="dialogVisible"
        width="550px"
        :before-close="handleClose">
      <el-form ref="labelPrint" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="数量"  prop="num">
          <el-input type="number" placeholder="请输入数量" v-model="form.num"></el-input>
        </el-form-item>
        <el-form-item label="生产日期" prop="productDate">
          <el-date-picker
            v-model="form.productDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择公司">
          <el-select class="search-input" v-model="companyId" @change="seach2" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择标签模板" prop="labelId">
          <el-select class="search-input" v-model="form.labelId" placeholder="请选择复用的标签模板">
            <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="添加标签(营销)"
        :visible.sync="dialogVisible2"
        width="550px"
        :before-close="handleClose">
      <el-form ref="labelPrint2" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="畜牧局信息上传">
          <el-upload
              ref="fileUpload"
              action=""
              :limit="1"
              :auto-upload="false"
              :on-change="handleChange"
              :on-remove="handleRemove">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="生产日期" prop="productDate">
          <el-date-picker
            v-model="form.productDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择公司">
          <el-select class="search-input" v-model="companyId" @change="seach2" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择标签模板" prop="labelId">
          <el-select class="search-input" v-model="form.labelId" placeholder="请选择复用的标签模板">
            <el-option v-for="item in list2" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="标签打印详情"
        :visible.sync="dialogVisible3"
        width="750px">
      <el-table
          ref="table"
          :data="currentRow.printDetailList"
          stripe
          size="mini"
          empty-text="暂无数据"
          row-class-name="table-row-cursor"
          header-row-class-name="header-row"
          :height="tableHeight"
          :maxHeight="tableHeight"
          style="width: 100%;">
        <el-table-column
            header-align="center"
            align="center"
            prop="number"
            label="唯一码">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            label="是否打印">
          <template slot-scope="scope">
            <div>{{scope.row.status === 0 ? '否' : '是'}}</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
            header-align="center"
            align="center"
            width="150"
            label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 0" size="mini" @click.stop="handlePrint(scope.row)">打印</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible4" title="标签打印" width="600px">
      <iframe v-if="dialogVisible4" :src="printUrl" frameborder="0" scrolling="no" style="width:100%;height:220px"></iframe>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiUpload } from '../../api/file'
  import { apiLabelList, apiLabelPrintList, apiLabelPrintEdit } from '../../api/label'

  export default {
    mixins: [tableMixin],
    name: 'userInfo',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        printUrl: '',
        list: [],
        list2: [],
        productList: [],
        file: null,
        pageIndex: 1,
        total: 0,
        currentRow: {
          printDetailList: []
        },
        companyId: null,
        id: 0,
        flag: '1', // 1.普通 2.营销
        query: {
          query: '',
          companyIds: []
        },
        form: {
          num: '',
          productDate: '',
          labelId: ''
        },
        rules: {
          num: [
            { required: true, message: '请输入数量', trigger: 'blur' }
          ],
          productDate: [
            { required: true, message: '请选择日期', trigger: 'change' }
          ],
          labelId: [
            { required: true, message: '请选择模板', trigger: 'change' }
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      if (this.userInfo.companyList) {
        this.query.companyIds.push(this.userInfo.companyList[0].id)
        this.companyId = this.userInfo.companyList[0].id
        this._getList()
        this.getLabelList()
      }
    },
    activated() {},
    methods: {
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 打开model
      openModel() {
        console.log(this.flag)
        if (this.flag === '1') {
          console.log(123)
          this.dialogVisible = true
        } else {
          this.dialogVisible2 = true
        }
        this.form = {
          num: '',
          productDate: new Date(),
          labelId: ''
        }
        if (this.$refs['labelPrint']) {
          this.$refs['labelPrint'].resetFields()
        }
        if (this.$refs['labelPrint2']) {
          this.$refs['labelPrint2'].resetFields()
        }
      },
      // 文件改变
      handleChange(file, files) {
        let arr = file.name.split('.')
        let suffix = arr[arr.length - 1]
        if (suffix !== 'txt') {
          this.$refs.fileUpload.clearFiles()
          this.$message({
            type: 'warning',
            message: '请上传txt文件'
          })
          return
        }
        this.file = file
      },
      // 移除文件
      handleRemove() {
        this.file = null
        console.log(this.file)
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
        }).catch(_ => {})
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      // 搜索2
      seach2() {
        this.getLabelList()
      },
      // 获取标签模板列表
      getLabelList(pageIndex = 1) {
        apiLabelList(2, 0, { companyIds: [this.companyId] }, pageIndex, 9999).then(data => {
          this.list2 = data.data.data
        })
      },
      // 获取列表批次列表
      _getList(pageIndex = 1) {
        if (this.query.companyIds.length === 0) return
        apiLabelPrintList(this.query, this.flag, 1, pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 打印
      handlePrint(row) {
        let detailList = row.printDetailList
        let file = row.file
        let printurl = 'http://dev.anschina.cn:8111/webroot/decision/view/report'
        let rp = []
        detailList.forEach(item => {
          if (item.status === 0) {
            rp.push({
              reportlet: 'ltms/' + file,
              id: item.id
            })
          }
        })
        /* eslint-disable */
        let reportlets = FR.cjkEncode(JSON.stringify(rp))
        let config = {
          printUrl: printurl,
          data: {
            reportlets: reportlets
          },
          isPopUp: false,
          printType: 0,
          pageType: 2,
          pageIndex: '1',
          copy: 1
        }
        FR.doURLPrint(config)
        // this.dialogVisible4 = true
        // let detail = []
        // let num = row.printDetailList.length
        // let name = encodeURI(row.product.name)
        // console.log(name)
        // console.log(decodeURI(name))
        // let batch = row.batch
        // let date = row.productDate
        // let report = row.label.number
        // let detailList = row.printDetailList
        // let file = row.file
        // detailList.forEach(item => {
        //   if (item.status === 0) {
        //     detail.push(item.id)
        //   }
        // })
        // detail = detail.join(',')
        // this.dialogVisible4 = true
        // this.printUrl = `http://106.14.162.223:8022/index.html?id=${row.id}&num=${num}&name=${name}&batch=${batch}&date=${date}&report=${report}&detail=${detail}&file=${file}`
        // this.printUrl = `http://localhost:8086/index.html?id=${row.id}&num=${num}&name=${name}&batch=${batch}&date=${date}&report=${report}&detail=${detail}&file=${file}`
      },
      // 详情
      handleDetail(row) {
        this.currentRow = row
        this.dialogVisible3 = true
      },
      // 新增
      handleAdd() {
        let labelPrint = {}
        if (this.flag === '1') {
          this.$refs['labelPrint'].validate((valid) => {
            if (valid) {
              labelPrint = {
                num: this.form.num,
                productDate: formatDate(this.form.productDate, 'YYYY-MM-DD'),
                companyId: this.companyId,
                labelId: this.form.labelId,
                origin: 1
              }
              apiLabelPrintEdit(labelPrint).then(data => {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.dialogVisible = false
                this._getList()
              })
            }
          })
        } else {
          this.$refs['labelPrint2'].validate((valid) => {
            if (valid) {
              if (this.file === null) {
                this.$message({
                  type: 'warning',
                  message: '请上传畜牧局信息'
                })
                return
              }
              let param = new FormData()
              param.append('file', this.file.raw, this.file.name)
              apiUpload(param).then(data => {
                labelPrint = {
                  num: 0,
                  text: data.data,
                  productDate: formatDate(this.form.productDate, 'YYYY-MM-DD'),
                  companyId: this.companyId,
                  labelId: this.form.labelId,
                  origin: 2
                }
                apiLabelPrintEdit(labelPrint).then(data => {
                  this.$message({
                    type: 'success',
                    message: '新增成功'
                  })
                  this.dialogVisible2 = false
                  this._getList()
                })
              })
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.label-print
    .el-form-item__content
      width 200px
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input2
        margin-right 10px
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
    .el-date-editor.el-input, .el-date-editor.el-input__inner
      width 200px
</style>
